import { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { CancelationModel } from '../models/CancelationModel';
import { getAll } from '../../../service/callcenter/Cancellation';

export const useGetAll = (realoadGrid: number, filters: any) => {
  const [data, setData] = useState<CancelationModel[]>([]);
  const [loadingRequest, setLoadingRequest] = useState(0);
  const history = useHistory();
  useEffect(() => {
    const fetchPost = async () => {
      setLoadingRequest(0);
      const res = await getAll(filters)
        .then()
        .catch((error) => {
          history.push('/error/500');
        });
      if (res) {
        setData(res.rows);
        setLoadingRequest(1);
      }
    };
    if (realoadGrid) {
      fetchPost();
    }
  }, [realoadGrid]);
  return { data, loadingRequest };
};
